import React, { useEffect, useState, useRef } from "react";
import Footer from "../../components/home_page/Footer";
import country from "../../pages/K_Company/Country.json";
import State from "../../pages/K_Company/State.json";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import FormData from "form-data";
import {
  getCompanyAlter,
  currentDateRedux,
  currentPeriodRedux,
} from "../../redux/actions/action-creator";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "../../components/model/modal.css";
import "../../components/login_form/registration.css";
import CreateConfirm from "../../components/Modal/CreateConfirm";
import { savePageFocus } from "../../redux/actions/action-creator";
import { useLocation } from "react-router-dom";
const Alter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData = null } = useSelector((state) => state.auth);

  const [showQuitModal, setShowQuitModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const lastFocusedElement = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Clear global history for this page and forcefully set it to first input
    dispatch(savePageFocus(location.pathname, "company_name"));
    setTimeout(() => {
      document.getElementById("company_name")?.focus();
    }, 10);
  }, [dispatch, location.pathname]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // If any modal is open, we only need to capture Escape to prevent global navigation leaks.
      // CreateConfirm handles Enter, y, n, and Arrow keys internally.
      if (showQuitModal) {
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopImmediatePropagation();
          setShowQuitModal(false);
          setTimeout(() => lastFocusedElement.current?.focus(), 10);
        }
        return; // Block other global hotkeys (like Ctrl+A) while modal is open
      }

      if (showAcceptModal) {
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopImmediatePropagation();
          setShowAcceptModal(false);
          setTimeout(() => lastFocusedElement.current?.focus(), 10);
        }
        return; // Block other global hotkeys while modal is open
      }

      // Ctrl+A: Accept
      if (e.ctrlKey && e.key.toLowerCase() === "a") {
        e.preventDefault();
        e.stopImmediatePropagation();
        const fakeEvent = { preventDefault: () => {} };
        handleSubmit(fakeEvent);
      }

      // Escape: Quit
      if (e.key === "Escape" && !showQuitModal && !showAcceptModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        lastFocusedElement.current = document.activeElement;
        setShowQuitModal(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }); // run on every render so it captures the latest state in handleSubmit

  const [data, setData] = useState({
    company_name: userData.company_name,
    mailing_name: userData.mailing_name,
    address: userData.address,
    city: userData.city,
    statename: userData.state,
    countryName: userData.country,
    pincode: userData.pincode,
    mobile: userData.mobile,
    telephone: userData.telephone,
    fax: userData.fax,
    email: userData.email,
    website: userData.website,
    fybfDate: userData.financial_year_begning_form,
    bbfDate: userData.books_being_date,
    username: userData.user_name,
    enable_tallyAudit_features: userData.enable_tally_audit_feature,
    maintain_multiple_branches_for_this_company: "",
    base_currency_symbol: userData.base_currancy_symbol,
    formal_name: userData.formal_name,
    suffix_symbol_to_amount: userData.suffex_symbol_amount,
    add_space_between_amount_and_symbol:
      userData.add_space_between_amount_symbol,
    number_of_decimal_places: userData.no_of_decimal_place,
    word_representing_amount_after_decimal:
      userData.word_reprenting_after_amount,
    number_fo_decimal_places_in_words: "2",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const {
    company_name,
    mailing_name,
    address,
    fybfDate,
    bbfDate,
    username,
    enable_tallyAudit_features,
    city,
    statename,
    countryName,
    pincode,
    mobile,
    telephone,
    fax,
    email,
    website,
    base_currency_symbol,
    formal_name,
    suffix_symbol_to_amount,
    add_space_between_amount_and_symbol,
    number_of_decimal_places,
    word_representing_amount_after_decimal,
    number_fo_decimal_places_in_words,
  } = data;

  const handleSubmit = (e1) => {
    e1.preventDefault();
    try {
      const requiredFields = [
        { field: "company_name", msg: "Please Fill the company name" },
        { field: "mailing_name", msg: "Please Fill the mailing Name" },
        { field: "fybfDate", msg: "Please Fill the date of financial year" },
        { field: "bbfDate", msg: "please fill the book date" },
        { field: "username", msg: "please fill the username" },
        { field: "city", msg: "please fill the city" },
        { field: "statename", msg: "please fill the state name" },
        { field: "countryName", msg: "please fill the country name" },
        { field: "pincode", msg: "please fill the pincode" },
        { field: "mobile", msg: "please fill the mobile number" },
        { field: "email", msg: "please fill the email" },
      ];

      for (let req of requiredFields) {
        if (!data[req.field] || data[req.field].toString().trim() === "") {
          alert(req.msg);
          return;
        }
      }

      let formData = new FormData();
      formData.append("id", userData.company_id);
      formData.append("user_name", username);
      formData.append("customer_code", userData.customer_code);
      formData.append("company_name", company_name);
      formData.append("mailing_name", mailing_name);
      formData.append("address", address);
      formData.append("city", city);
      formData.append("state", statename);
      formData.append("country", countryName);
      formData.append("pincode", pincode);
      formData.append("mobile", mobile);
      formData.append("telephone", telephone);
      formData.append("fax", fax);
      formData.append("email", email);
      formData.append("website", website);
      formData.append("formal_name", formal_name);
      formData.append("suffex_symbol_amount", suffix_symbol_to_amount);
      formData.append("base_currancy_symbol", base_currency_symbol);
      formData.append(
        "add_space_between_amount_symbol",
        add_space_between_amount_and_symbol,
      );
      formData.append("financial_year_begning_form", fybfDate);
      formData.append("books_being_date", bbfDate);
      formData.append("enable_tally_audit_feature", enable_tallyAudit_features);
      formData.append("no_of_decimal_place", number_of_decimal_places);
      formData.append(
        "word_reprenting_after_amount",
        number_fo_decimal_places_in_words,
      );
      formData.append("no_of_decimal_place_for_amount", "");

      const toDisplayDate = (rawDate) => {
        if (!rawDate) return "";
        const dateObj = new Date(rawDate);
        if (Number.isNaN(dateObj.getTime())) return "";
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = dateObj.toLocaleString("default", { month: "short" });
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const startDateObj = new Date(fybfDate);
      const periodEndObj = new Date(startDateObj);
      periodEndObj.setFullYear(periodEndObj.getFullYear() + 1);
      periodEndObj.setDate(periodEndObj.getDate() - 1);

      dispatch(getCompanyAlter(formData))
        .then((response) => {
          if (response.status) {
            const startDisplay = toDisplayDate(fybfDate);
            const endDisplay = toDisplayDate(periodEndObj);
            const currentDisplay = toDisplayDate(bbfDate);
            const currentDay = currentDisplay
              ? new Date(bbfDate).toLocaleString("en-US", { weekday: "long" })
              : "";

            if (startDisplay && endDisplay) {
              dispatch(
                currentPeriodRedux({
                  financl_year: `${startDisplay} To ${endDisplay}`,
                  start_fincl_year: startDisplay,
                  end_fincl_year: endDisplay,
                  cur_date: currentDisplay
                    ? `${currentDay},${currentDisplay}`
                    : "",
                }),
              );
            }

            if (currentDisplay) {
              dispatch(currentDateRedux(`${currentDay},${currentDisplay}`));
            }

            toast.success(response?.message || "Update Success!", {
              position: toast.POSITION.TOP_CENTER,
            });
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          } else {
            toast.warn(response?.message || "Update Fail !", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        })
        .catch((error) => {
          toast.error(error?.message || "Update Failed!", {
            position: toast.POSITION.TOP_CENTER,
          });
        });
    } catch (error) {
      alert(`error${error}`);
    }
  };

  const handleFormKeyDown = (e) => {
    // Prevent Enter from submitting the form and handle navigation
    if (e.key === "Enter") {
      e.preventDefault(); // Crucial: prevents the native form submit which causes reload/sign out

      const form = e.currentTarget;
      const elements = Array.from(form.elements);
      const focusable = elements.filter(
        (el) =>
          !el.disabled &&
          el.tabIndex >= 0 &&
          (el.tagName === "INPUT" ||
            el.tagName === "SELECT" ||
            el.tagName === "TEXTAREA"),
      );

      const currentIndex = focusable.indexOf(e.target);

      if (e.shiftKey) {
        // Shift+Enter goes backward
        if (currentIndex > 0) {
          focusable[currentIndex - 1].focus();
        }
      } else {
        // Enter goes forward
        if (currentIndex > -1 && currentIndex < focusable.length - 1) {
          focusable[currentIndex + 1].focus();
        } else if (currentIndex === focusable.length - 1) {
          // Last input, show accept modal
          lastFocusedElement.current = e.target;
          e.target.blur();
          setShowAcceptModal(true);
        }
      }
    }
  };

  return (
    <div className="section">
      <div className="detail border">
        {showQuitModal && (
          <CreateConfirm
            message="Quit"
            handleSubmit={(e) => {
              if (e && e.preventDefault) {
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation();
              }
              navigate(-1);
            }}
            handleFocusReset={(e) => {
              if (e && e.preventDefault) {
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation();
              }
              setShowQuitModal(false);
              setTimeout(() => lastFocusedElement.current?.focus(), 10);
            }}
          />
        )}
        {showAcceptModal && (
          <CreateConfirm
            message="Accept"
            handleSubmit={(e) => {
              if (e && e.preventDefault) {
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation();
              }
              const fakeEvent = { preventDefault: () => {} };
              handleSubmit(fakeEvent);
              setShowAcceptModal(false);
            }}
            handleFocusReset={(e) => {
              if (e && e.preventDefault) {
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation();
              }
              setShowAcceptModal(false);
              setTimeout(() => lastFocusedElement.current?.focus(), 10);
            }}
          />
        )}
        <div className="container-fluid bg-light pb-2">
          <ToastContainer />
          <div className="row mt-4">
            <div className="col">
              <form
                method="POST"
                autoComplete="off"
                onSubmit={handleSubmit}
                onKeyDown={handleFormKeyDown}
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Company Name</label>
                      <label> :</label>
                      <input
                        type="text"
                        name="company_name"
                        id="company_name"
                        autoFocus
                        tabIndex="1"
                        className="lab-right"
                        value={company_name || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Mailing Name </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="mailing_name"
                        id="mailing_name"
                        tabIndex="2"
                        className="lab-right"
                        value={mailing_name || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Address </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="address"
                        className="lab-right"
                        tabIndex="3"
                        value={address || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1">
                        {" "}
                        Financial year beginning from{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="date"
                        name="fybfDate"
                        id="fybfDate"
                        className="lab-right"
                        tabIndex="4"
                        value={fybfDate || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Books beginning from</label>
                      <label> :</label>
                      <input
                        type="date"
                        name="bbfDate"
                        id="bbfDate"
                        className="lab-right"
                        tabIndex="5"
                        value={bbfDate || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <p>Security</p>

                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Username (Administrator)</label>
                      <label> :</label>
                      <input
                        type="text"
                        name="username"
                        id="username"
                        className="lab-right"
                        tabIndex="6"
                        value={username || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> City </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        value={city || " "}
                        className="lab-right"
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div
                      className="d-flex justify-content-between align-item-center"
                      id="state"
                    >
                      <label className="lab-1"> State </label>
                      <label> :</label>
                      <input
                        type="text"
                        list="state_list"
                        name="statename"
                        id="stateName"
                        className="lab-right"
                        value={statename || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                      <datalist id="state_list" className="lab-right">
                        {State.map((item, index) => {
                          return <option value={item.name}>{item.name}</option>;
                        })}
                      </datalist>
                    </div>
                    <div
                      className="d-flex justify-content-between align-item-center"
                      id="country"
                    >
                      <label className="lab-1"> Country </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="countryName"
                        list="country_list"
                        id="countryName"
                        value={countryName || ""}
                        className="lab-right"
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        required
                      />
                      <datalist id="country_list" className="lab-right">
                        {country.map((item, index) => {
                          return <option value={item.name}>{item.name}</option>;
                        })}
                      </datalist>
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Pincode </label>
                      <label> :</label>
                      <input
                        type="number"
                        name="pincode"
                        id="pincode"
                        value={pincode || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Mobile </label>
                      <label> :</label>
                      <input
                        type="number"
                        name="mobile"
                        id="mobile"
                        value={mobile || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Telephone </label>
                      <label> :</label>
                      <input
                        type="number"
                        name="telephone"
                        id="telephone"
                        value={telephone || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Fax </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="fax"
                        id="fax"
                        value={fax || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> E-Mail </label>
                      <label> :</label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={email || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Website </label>
                      <label> :</label>
                      <input
                        type="website"
                        name="website"
                        id="website"
                        value={website || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                  </div>
                  <div className="border mt-2"></div>
                </div>
                <div className="row pt-3">
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1 text-truncate">
                        {" "}
                        Base Currency symbol{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="base_currency_symbol"
                        id="base_currency_symbol"
                        value={base_currency_symbol || ""}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Formal name </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="formal_name"
                        id="formal_name"
                        value={formal_name || " "}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1"> Suffix symbol to amount </label>
                      <label> :</label>
                      <input
                        type="text"
                        list="ssta"
                        name="suffix_symbol_to_amount"
                        id="suffix_symbol_to_amount"
                        value={suffix_symbol_to_amount || ""}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                      <datalist id="ssta">
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </datalist>
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1 text-truncate">
                        {" "}
                        Add space between amount and symbol{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="text"
                        list="asbaas"
                        name="add_space_between_amount_and_symbol"
                        id="add_space_between_amount_and_symbol"
                        value={add_space_between_amount_and_symbol || ""}
                        className="lab-right"
                        onKeyUp={handleChange}
                        onChange={handleChange}
                      />
                      <datalist id="asbaas">
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </datalist>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1">
                        {" "}
                        Number of decimal places{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="number"
                        name="number_of_decimal_places"
                        id="number_of_decimal_places"
                        value={number_of_decimal_places || ""}
                        className="lab-right"
                        onKeyUp={handleChange}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1 text-nowrap text-truncate">
                        {" "}
                        Word representing amount after decimal{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="word_representing_amount_after_decimal"
                        id="word_representing_amount_after_decimal"
                        value={word_representing_amount_after_decimal || ""}
                        onChange={handleChange}
                        onKeyUp={handleChange}
                        className="lab-right"
                      />
                    </div>
                    <div className="d-flex justify-content-between align-item-center mb-1">
                      <label className="lab-1 text-nowrap text-truncate">
                        {" "}
                        Number of decimal places for amount in words{" "}
                      </label>
                      <label> :</label>
                      <input
                        type="text"
                        name="number_fo_decimal_places_in_words"
                        id="number_fo_decimal_places_in_words"
                        value={number_fo_decimal_places_in_words || ""}
                        onKeyUp={handleChange}
                        onChange={handleChange}
                        className="lab-right"
                      />
                    </div>
                  </div>
                </div>
                <div className="tomasterfooter">
                  <Footer />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Alter;
